export const validatorsForm: {
    [index: string]: {
        [index: string]: string
    }
} = {
    razaoSocial: {
        required: 'Razão Social é um campo obrigatório',
        min: 'Razão Social deve ter pelo menos 3 caracteres',
        max: 'Razão Social deve ter no máximo 64 caracteres',
        matches: 'Razão Social informado é inválido'
    },
    cpf: {
        required: 'O CPF é um campo obrigatório',
        matches: 'O CPF informado é inválido',
        invalid: 'O CPF informado é inválido'
    },
    cnpj: {
        required: 'O CNPJ é um campo obrigatório',
        matches: 'O CNPJ informado é inválido',
        invalid: 'O CNPJ informado é inválido'
    },
    registro: {
        required: 'O CNPJ/CPF é um campo obrigatório',
        matches: 'O CNPJ/CPF informado é inválido',
        invalid: 'O CNPJ/CPF informado é inválido'
    },
    celular: {
        required: 'Celular é um campo obrigatório',
        matches: 'O número de celular informado é inválido'
    },
    telefone: {
        required: 'Telefone é um campo obrigatório',
        matches: 'O número de telefone informado é inválido'
    },
    contato: {
        required: 'Contato é um campo obrigatório',
        matches: 'O número de celular/telefone informado é inválido'
    },
    email: {
        required: 'E-mail é um campo obrigatório',
        email: 'O e-mail informado é inválido'
    },
    cep: {
        required: 'CEP é um campo obrigatório',
        matches: 'O CEP informado é inválido'
    },
    logradouro: {
        required: 'Logradouro é um campo obrigatório'
    },
    numero: {
        required: 'Número é um campo obrigatório'
    },
    bairro: {
        required: 'Bairro é um campo obrigatório'
    },
    municipio: {
        required: 'Cidade é um campo obrigatório'
    },
    uf: {
        required: 'UF é um campo obrigatório'
    },
    ufGravame: {
        required: 'UF gravame é um campo obrigatório'
    },
    ufPlaca: {
        required: 'UF Placa é um campo obrigatório'
    },
    placa: {
        required: 'Placa é um campo obrigatório',
        invalid: 'A Placa informada é inválida'
    },
    nome: {
        required: 'Nome é um campo obrigatório',
        min: 'Nome deve ter pelo menos 3 caracteres'
    },
    nomeUsuario: {
        required: 'Nome de usuário é um campo obrigatório'
    },
    senha: {
        required: 'Senha é um campo obrigatório',
        matches: 'O formato da senha informado é inválido',
        min: 'Senha deve ter pelo menos 8 caracteres',
        max: 'Senha deve ter no máximo 30 caracteres'
    },
    senhaConfirmacao: {
        required: 'Confirmação de senha é um campo obrigatório'
    },
    codigo: {
        required: 'Código é um campo obrigatório',
        typeError: 'O código informado é inválido'
    },
    codigoConfirmacao: {
        required: 'Código é um campo obrigatório',
        typeError: 'O código informado é inválido'
    },
    codigoInstituicaoFinanceira: {
        required: 'Código da IF é um campo obrigatório',
        typeError: 'O código da IF é inválido'
    },
    chassi: {
        required: 'O Chassi é um campo obrigatório',
        matches: 'O Chassi informado é inválido',
        invalid: 'O Chassi informado é inválido'
    },
    anoFabricacao: {
        required: 'O Ano fabricação é um campo obrigatório',
        invalid: 'O Ano fabricação informado é inválido',
        typeError: 'O Ano fabricação é um campo obrigatório'
    },
    anoModelo: {
        required: 'O Ano modelo é um campo obrigatório',
        invalid: 'O Ano modelo informado é inválido',
        typeError: 'O Ano modelo é um campo obrigatório'
    },
    renavam: {
        required: 'O Renavam é um campo obrigatório',
        invalid: 'O Renavam informado é inválido'
    },
    dataContrato: {
        required: 'A Data Contrato é um campo obrigatório',
        invalid: 'A Data Contrato informado é inválido'
    },
    numeroContrato: {
        required: 'Nº do contrato é um campo obrigatório',
        invalid: 'Nº  do contrato informado é inválido'
    },
    numeroGravame: {
        required: 'Nº do gravame é um campo obrigatório',
        invalid: 'Nº do gravame informado é inválido'
    },
    valorTaxaMulta: {
        required: 'Taxa de multa é um campo obrigatório',
        invalid: 'Taxa de multa informado é inválido'
    },
    valorTaxaMora: {
        required: 'Taxa de mora é um campo obrigatório',
        invalid: 'Taxa de mora informado é inválido'
    },
    indices: {
        required: 'Índices é um campo obrigatório',
        invalid: 'Índices informado é inválido'
    },
    principalRecebedorPagamento: {
        required: 'Principal recebedor do pagamento é um campo obrigatório',
        invalid: 'Principal recebedor do pagamento informado é inválido'
    },
    tipoDocumentoRecebedor: {
        required: 'Doc. recebedor é um campo obrigatório',
        invalid: 'Doc. recebedor informado é inválido'
    },
    documentoPrincipalRecebedorPagamento: {
        required: 'Nº do documento é um campo obrigatório',
        invalid: 'Nº do documento informado é inválido',
        matches: 'Nº do documento informado é inválido'
    },
    tipoDocumentoVendedor: {
        required: 'Doc. vendedor é um campo obrigatório',
        invalid: 'Doc. vendedor informado é inválido'
    },
    documentoVendedor: {
        required: 'Nº do documento é um campo obrigatório',
        invalid: 'Nº do documento informado é inválido',
        matches: 'Nº do documento informado é inválido'
    },
    identificadorComissao: {
        required: 'Comissão é um campo obrigatório',
        invalid: 'Comissão informado é inválido'
    },
    indicacaoPenalidade: {
        required: 'Penalidade é um campo obrigatório',
        invalid: 'Penalidade informado é inválido'
    },
    valorTotalDivida: {
        required: 'Valor total da dívida é um campo obrigatório',
        invalid: 'Valor total da dívida informado é inválido'
    },
    valorParcela: {
        required: 'Valor da parcela é um campo obrigatório',
        invalid: 'Valor da parcela informado é inválido'
    },
    dataLiberacaoCredito: {
        required: 'Data Liberação de crédito é um campo obrigatório',
        invalid: 'Data Liberação de crédito informado é inválido'
    },
    ufContrato: {
        required: 'UF do contrato é um campo obrigatório',
        invalid: 'UF do contrato informado é inválido'
    },
    municipioContrato: {
        required: 'Município é um campo obrigatório',
        invalid: 'Município informado é inválido'
    },
    vencimentoPrimeiraParcela: {
        required: 'Vencimento 1ª parcela é um campo obrigatório',
        invalid: 'Vencimento 1ª parcela informado é inválido'
    },
    vencimentoUltimaParcela: {
        required: 'Vencimento da última parcela é um campo obrigatório',
        invalid: 'Vencimento da última parcela informado é inválido'
    },
    quantidadeMeses: {
        required: 'Quantidade de meses é um campo obrigatório',
        matches: 'Quantidade de meses informado é inválido',
        typeError: 'Quantidade de meses é um campo obrigatório'
    },
    identificacaoRemarcacao: {
        required: 'Remarcado é um campo obrigatório',
        typeError: 'Remarcado é um campo obrigatório'
    },
    cor: {
        required: 'Cor é um campo obrigatório',
        typeError: 'Cor é um campo obrigatório'
    },
    marca: {
        required: 'Marca/Modelo é um campo obrigatório',
        typeError: 'Marca/Modelo é um campo obrigatório'
    },
    especie: {
        required: 'Especie do Veiculo é um campo obrigatório',
        typeError: 'Especie do Veiculo é um campo obrigatório'
    },
    numeroDudaPago: {
        required: 'Número do DUDA é um campo obrigatório',
        typeError: 'Número do DUDA é um campo obrigatório'
    },
    tipoRestricao: {
        required: 'Tipo de restrição é um campo obrigatório',
        typeError: 'Tipo de restrição é um campo obrigatório'
    },
    cotaConsorcio: {
        required: 'Cota do consórcio é um campo obrigatório'
    },
    numeroGrupo: {
        required: 'Nº do grupo é um campo obrigatório'
    },
    complemento: {
        required: 'Complemento é um campo obrigatório'
    },
    tipoDocumento: {
        required: 'Doc. recebedor é um campo obrigatório'
    },
    documento: {
        required: 'Nº do documento é um campo obrigatório',
        invalid: 'Nº do documento informado é inválido',
        matches: 'Nº do documento informado é inválido'
    },
    valorComissao: {
        required: 'Valor de comissão é um campo obrigatório',
        invalid: 'Valor de comissão informado é inválido'
    },
    penalidade: {
        required: 'Valor de penalidade é um campo obrigatório',
        invalid: 'Valor de penalidade informado é inválido'
    },
    agenteFinanceiroVinculo: {
        required: 'Selecione um Agente financeiro',
        invalid: 'Selecione um Agente financeiro'
    },
    dataInicio: {
        invalid: 'A Data informada é inválida'
    },
    dataFinal: {
        invalid: 'A Data informada é inválida'
    },
    dataAditivo: {
        invalid: 'A Data informada é inválida'
    },
    categorizacao: {
        required: 'Categorização é um campo obrigatório',
        invalid: 'Categorização é um campo obrigatório'
    },
    expectativaRegistroContratoDiario: {
        required: 'Estimativa Registro Dia é um campo obrigatório',
        invalid: 'Estimativa Registro Dia é um campo obrigatório'
    },
    instituicaoPagaTaxa: {
        required: 'Instituição paga a taxa, é um campo obrigatório',
        invalid: 'Instituição paga a taxa, é um campo obrigatório'
    }
}
